import axios from 'axios';

import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import '@/modules/ad-manager';

Vue.use(VueRouter);
Vue.use(Vuex);

Vue.config.productionTip = false;

const App = () => import('./App.vue');
const HomepageView = () => import('./views/Homepage');
const SubpageView = () => import('./views/Subpage');
const SubpageSearchView = () => import('./views/Subpage/Search');
const SubpagePrivacyView = () => import('./views/Subpage/Privacy');
const SubpageUnsubView = () => import('./views/Subpage/Unsub');
const SubpageTermsView = () => import('./views/Subpage/Terms');

const router = new VueRouter({
  mode: 'history',
  routes: [
    { name: 'homepage', path: '', component: HomepageView },
    { name: 'subpage', path: '', component: SubpageView,
      children: [
        {
          name: 'search',
          path: '/:keyword/:location/:page?',
          component: SubpageSearchView
        },
        {
          name: 'privacy',
          path: '/privacy',
          component: SubpagePrivacyView
        },
        {
          name: 'unsub',
          path: '/unsubscribe',
          component: SubpageUnsubView
        },
        {
          name: 'terms',
          path: '/terms',
          component: SubpageTermsView
        }
      ]
    }
  ]
});

router.afterEach(to => {
  axios.post(
    process.env.VUE_APP_METRICS_API + '/page-view',
    {
        campaign: {
            id: store.state.user.cid
        },
        user: {
            email: store.state.user.email,
            pid: store.state.user.pid
        },
        search: {
            keyword: store.state.search.keyword,
            location: store.state.search.location,
            daysAgo: store.state.search.age,
            radius: store.state.search.distance,
            provider: process.env.VUE_APP_JOB_PROVIDER
        },
        page: {
            url: to.fullPath,
            type: to.name
        }
    }
  ).then(res => {
    const data = res.data;
    if (data.success) {
      store.commit('uuid', data.uuid);
    }
  });
  const inboundKeys = ['email', 'cid'];
  const query = Object.assign({}, to.query);
  let replace = false;
  for (let key of inboundKeys) {
    if (typeof to.query[key] !== "undefined") {
      let commit = {};
      commit[key] = to.query[key];
      store.commit('inbound', commit);
      delete query[key];
      replace = true;
    }
  }
  if (replace) {
    router.replace({ query });
  }
});

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

const store = new Vuex.Store({
  state: {
    search: {
      keyword: '',
      location: '',
      distance: 15,
      age: 7
    },
    user: {
      email: '',
      cid: '',
      pid: process.env.VUE_APP_ORGANIC_PID
    },
    metrics: {
      uuid: ''
    }
  },
  mutations: {
    uuid (state, payload) {
      state.metrics.uuid = payload;
    },
    search (state, payload) {
      for (let key in payload) {
        state.search[key] = payload[key];
      }
    },
    inbound (state, payload) {
      for (let key in payload) {
        state.user[key] = payload[key];
      }
    }
  },
  plugins: [ vuexLocal.plugin ]
});

Vue.mixin({
  data () {
    return {
      searchForm: {
        keyword: this.$route.params.keyword || this.$store.state.search.keyword,
        location: this.$route.params.location || this.$store.state.search.location,
        distance: this.$store.state.search.distance,
        age: this.$store.state.search.age
      },
      user: this.$store.state.user,
      site: {
        address: {
          line1: process.env.VUE_APP_ADDRESS_LINE_1,
          line2: process.env.VUE_APP_ADDRESS_LINE_2
        }
      }
    }
  },
  methods: {
    includeScript ( URL, callback, async ) {
        async = typeof async === "undefined" ? false : true;
        const scripts = document.getElementsByTagName('script');
        for (let i = scripts.length; i--;) {
            if (scripts[i].src == URL) {
                return callback();
            }
        }
        let documentTag = document, tag = 'script',
            object = documentTag.createElement(tag),
            scriptTag = documentTag.getElementsByTagName(tag)[0];
        object.src = URL;
        object.defer = true;
        object.async = async;
        if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
        scriptTag.parentNode.insertBefore(object, scriptTag);

        return object;
    },
    updateSearch () {
      this.$store.commit('search', this.searchForm);
    },
    gotoResults () {
      return this.$router.push({
        name: 'search',
        params: {
          location: this.searchForm.location,
          keyword: this.searchForm.keyword
        }
      });
    },
    search () {
      this.updateSearch();
      return this.gotoResults();
    },
    canSearch () {
      if (!this.searchForm.keyword.length || !this.searchForm.location.length) {
        return false;
      }

      return true;
    },
    cleanQueryString () {
      const inboundKeys = ['email', 'cid'];
      const query = Object.assign({}, this.$route.query);
      let replace = false;
      for (let key of inboundKeys) {
        if (typeof this.$route.query[key] !== "undefined") {
          let commit = {};
          commit[key] = this.$route.query[key];
          this.$store.commit('inbound', commit);
          delete query[key];
          replace = true;
        }
      }
      if (replace) {
        this.$router.replace({ query });
      }
    },
    openSupportForm () {
      document.getElementById('launcher-frame').contentWindow.document.getElementsByClassName('launcher-button')[0].click();
    }
  }
});

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
